Object.defineProperty(exports, "__esModule", { value: true });
exports.register = void 0;
const transforms_1 = require("../utils/transforms");
const shared = require("@volar/shared");
function register(languageService, getTextDocument) {
    return (uri, position) => {
        const document = getTextDocument(uri);
        if (!document)
            return [];
        const fileName = shared.uriToFileName(document.uri);
        const offset = document.offsetAt(position);
        let entries;
        try {
            entries = languageService.getTypeDefinitionAtPosition(fileName, offset);
        }
        catch (_a) { }
        if (!entries)
            return [];
        return (0, transforms_1.entriesToLocationLinks)([...entries], getTextDocument);
    };
}
exports.register = register;
//# sourceMappingURL=typeDefinition.js.map